import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fromWithCompany } from "../config/supabaseClient";

export const fetchYearId = createAsyncThunk(
  "years/fetchYearId",

  async (_, { rejectWithValue }) => {
    try {
      const { data, error } = await fromWithCompany("year")
        .select("*")
        .eq("status", true)
        .lte("start_date", new Date().toISOString())
        .gte("end_date", new Date().toISOString())
        .single();

      if (error) {
        throw error;
      }

      return data.id;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchYearData = createAsyncThunk(
  "years/fetchYearData",

  async (_, { rejectWithValue }) => {
   
    try {
      
      const { data, error } = await fromWithCompany("year")
        .select("*")
        .eq("status", true)
        .lte("start_date", new Date().toISOString())
        .gte("end_date", new Date().toISOString())
        .single();

      if (error) {
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
);

const yearSlice = createSlice({
  name: "years",
  initialState: {
    years: [],
    loading: false,
    error: null,
  },
  reducers: {},
});

export default yearSlice.reducer;
